import { observer } from 'mobx-react-lite';
import React from 'react';
import styles from '../program-sheet.module.scss';

import Typography from '@smart-tv/components/typography';
import testIds from '@smart-tv/e2e/shared/variables';

type CrewJob = 'Instruktør' | 'Skuespiller';

export type CrewMember = {
  personId: number;
  firstName: string;
  lastName: string;
  job: CrewJob;
};

interface CrewProps {
  variant?: 'director' | 'actor';
  crew?: CrewMember[];
}

export const ProgramSheetContentCrew = observer((props: CrewProps) => {
  const { variant, crew } = props;

  let crewJob: CrewJob;
  let memberRole: string;

  switch (variant) {
    case 'director':
      crewJob = 'Instruktør';
      memberRole = 'Instruktører';
      break;
    default:
      crewJob = 'Skuespiller';
      memberRole = 'Medvirkende';
  }

  const crewData = crew?.filter(
    (member) =>
      member.job === crewJob &&
      member.firstName.trim().length > 0 &&
      member.lastName.trim().length > 0
  );

  if (!crewData?.length || !memberRole?.trim().length) {
    return null;
  }

  return (
    <div
      data-testid={testIds.programsheet.content.actors}
      className={styles['sheet-description-extended__crew']}
    >
      <Typography variant="caption" color="textSecondary" gutterBottom={2}>
        {memberRole}
      </Typography>
      <Typography variant="bodySmall">
        {crewData.map((member, index) => {
          return (
            <React.Fragment key={member.personId}>
              {member.firstName + ' ' + member.lastName}
              {index < crewData.length - 1 ? ', ' : ''}
            </React.Fragment>
          );
        })}
      </Typography>
    </div>
  );
});

export default ProgramSheetContentCrew;
